import { render, staticRenderFns } from "./exhibition-card-vip.vue?vue&type=template&id=18ec903e&scoped=true&"
import script from "./exhibition-card-vip.vue?vue&type=script&lang=js&"
export * from "./exhibition-card-vip.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-card-vip.vue?vue&type=style&index=0&id=18ec903e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ec903e",
  null
  
)

export default component.exports